import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import { I18nTranslator } from '../../../../i18n/translate';
import { ARBleCampaign, ARBleOrder } from '../../../../models/agrorendement-ble.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { HectareConverterPipe } from '../../../../pipes/hectareConverter.pipe';
import { ListFarmsForOrderPipe, ListUsersForOrderPipe } from '../../../../pipes/orders.pipe';
import { ARBleService } from '../../../../services/agrorendement-ble.service';
import { FarmService } from '../../../../services/farm.service';
import { OrganisationService } from '../../../../services/organisation.service';
import { OrderComponent } from '../common/orders.component';
import { ARBleUtils } from './ble.utils';
import { TranslatePipe, TranslateDatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'ar-ble-orders-cmp',
  templateUrl: '../common/orders.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    CommonModule,
    FormsModule,
    CampaignYearPipe,
    HectareConverterPipe,
    ListUsersForOrderPipe,
    ListFarmsForOrderPipe,
    TranslatePipe,
    TranslateDatePipe,
    TranslateWithPunctuationPipe,
    PaginationModule,
  ],
  providers: [ARBleService, FarmService, OrganisationService],
})
export class ARBleOrderComponent extends OrderComponent<ARBleCampaign, ARBleOrder> implements OnInit, AfterViewInit {
  @ViewChild('termCampaignFilter') termCampaignFilter: ElementRef;
  @ViewChild('termFarmFilter') termFarmFilter: ElementRef;
  @ViewChild('termOrganisationFilter') termOrganisationFilter: ElementRef;
  @ViewChild('allFilters', { static: true }) allFilters: ElementRef;

  constructor(
    protected service: ARBleService,
    protected farmService: FarmService,
    protected organisationService: OrganisationService,
    protected i18nTranslator: I18nTranslator,
    protected router: Router,
    protected modal: ModalService,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.ble.section');
    this.specyUrlPart = ['azote', 'ble'];
    this.specyOrderCode = 'ORDB';
  }

  isOrderEditable(order: ARBleOrder): boolean {
    return ARBleUtils.isOrderEditable(order);
  }
}
